/* eslint-disable import/no-cycle */
import { getCustomerIdUtils } from '../index-utils';

export const setMrCartHash = hash => {
  sessionStorage.setItem('mr_cart_hash', hash);
};

export const getMrCartHash = () => sessionStorage.getItem('mr_cart_hash');

export const getCustomerId = () => getCustomerIdUtils();
